<script>
  let { formattedPrice } = $props();
</script>

<div class="reco_aos_product_bundle_item__right_side">
  {#if formattedPrice.originalPrice === undefined || formattedPrice.retailPrice === formattedPrice.originalPrice}
    <div class="oc-copy-100 oc-copy--bold">{formattedPrice.retailPrice}</div>
  {:else}
    <div class="color-red oc-copy-100 oc-copy--bold">
      {formattedPrice.retailPrice}
    </div>
    <div class="line-through oc-copy-75">{formattedPrice.originalPrice}</div>
  {/if}
</div>

<style lang="scss">
  .reco_aos_product_bundle_item__right_side {
    display: flex;
    width: 80px;
    flex-direction: column;
    align-items: flex-end;
    flex-shrink: 0;
    margin-left: 8px;
    text-wrap: nowrap;
  }
  .reco_aos_product_bundle_item__right_side .line-through {
    text-decoration: line-through;
  }

  .reco_aos_product_bundle_item__right_side .color-red {
    color: var(--oc-semantic-color-brand);
  }
</style>
